import {
  CustomizationIngredientsGridContainer,
  CustomizationIngredientsGridNav,
  CustomizationIngredientsGridNavItem,
  CustomizationIngredientsGridNavItemCustom,
  CustomizationIngredientsGridSection,
  CustomizationIngredientsGridSectionStack,
} from './components';

export const CustomizationIngredientsGrid = {
  Nav: CustomizationIngredientsGridNav,
  NavItem: CustomizationIngredientsGridNavItem,
  NavItemCustom: CustomizationIngredientsGridNavItemCustom,
  Container: CustomizationIngredientsGridContainer,
  Section: CustomizationIngredientsGridSection,
  SectionStack: CustomizationIngredientsGridSectionStack,
};
